module.exports = __webpack_public_path__ + "public/img/设置.0fd4c320.png";